/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedautomovenoshowenabled5Inputs */

const en__field_inheritedautomovenoshowenabled5 = /** @type {(inputs: _Field_Inheritedautomovenoshowenabled5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`automatic no-show moving enabled (derived)`)
};

const de__field_inheritedautomovenoshowenabled5 = /** @type {(inputs: _Field_Inheritedautomovenoshowenabled5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto No-Show-Setzen aktiv (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "automatic no-show moving enabled (derived)" |
*
* @param {_Field_Inheritedautomovenoshowenabled5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedautomovenoshowenabled5 = /** @type {((inputs?: _Field_Inheritedautomovenoshowenabled5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedautomovenoshowenabled5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedautomovenoshowenabled5(inputs)
	return de__field_inheritedautomovenoshowenabled5(inputs)
});
export { _field_inheritedautomovenoshowenabled5 as "_field_inheritedAutoMoveNoShowEnabled" }